// extracted by mini-css-extract-plugin
export default {"fields":"eXWf4_","time":"oWl50z","mobile":"SUk_uQ"};